import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import course05 from "../../../course/course-05/course";
import lesson0506 from "../../course-05/lesson-06/lesson";
import lesson0301 from "../lesson-01/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "cbfa6bf2-d23c-4775-98a5-e52352d76d7f",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0301),
    lesson: lesson0301,
  },
  {
    id: "dc9a4068-fa88-4d47-b05b-262658785320",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0506),
    lesson: lesson0506,
  },
];

export default lessonLinks;
